import { education, experience, volunteering } from "content/site/siteData";

export const pageItems = [...education, ...experience, ...volunteering];
